import { useSnapshot } from "valtio";
import store from "./appStore";

const useStoreLocation = () => {
  const { appLocation } = useSnapshot(store);

  const setAppLocation = (location) => {
    store.appLocation = location;
  };

  return [appLocation, setAppLocation];
};

export default useStoreLocation;
